module.exports = __webpack_public_path__ + "static/media/MATH61.2cbe98c9.PNG";